import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from 'src/app/app.constants';
import { Observable } from 'rxjs';
import { EventTypeListItemViewModel } from '../viewModels/events/eventTypeListItemViewModel';
import { EventTypeDetailsViewModel } from '../viewModels/events/eventTypeDetailsViewModel';
import { EventViewModel } from '../viewModels/events/eventViewModel';
import { FilterViewModel } from '../models/filter/filterViewModel';
import { LightFilterUpdateModel } from '../models/filter/LightFilterUpdateModel';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configuration: Configuration) {
    this.baseUrl = this.configuration.buildEndpoint('Events/');
  }

  addEvent(event: EventViewModel) {
    return this.http.post<EventViewModel>(`${this.baseUrl}AddEvent`, event);
  }

  updateEventLight(item: LightFilterUpdateModel) {
    return this.http.post<LightFilterUpdateModel>(`${this.baseUrl}UpdateLight`, item);
  }

  editEvent(event: EventViewModel) {
    return this.http.post<EventViewModel>(`${this.baseUrl}EditEvent`, event);
  }

  getEventDetails(eventId: number): Observable<EventViewModel> {
    return this.http.get<EventViewModel>(`${this.baseUrl}GetEventDetails/${eventId}`);
  }

  getEventList(filters: FilterViewModel[], splitEventsByBookedDatesForCalendar?: boolean): Observable<EventViewModel[]> {
    let url = this.baseUrl + 'GetEventsList';

    // Add query parameter if specified
    if (splitEventsByBookedDatesForCalendar !== undefined) {
      url += `?splitEventsByBookedDatesForCalendar=${splitEventsByBookedDatesForCalendar}`;
    }

    return this.http.post<EventViewModel[]>(url, filters);
  }

  getLiveEvents(): Observable<EventViewModel[]> {
    return this.http.get<EventViewModel[]>(this.baseUrl + 'GetLiveEvents');
  }

  deleteEvents(Ids: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}DeleteEvents`, Ids);
  }

  getEventTypeList(): Observable<EventTypeListItemViewModel[]> {
    return this.http.get<EventTypeListItemViewModel[]>(this.baseUrl + 'GetEventTypesList');
  }

  getEventTypesListForEvent(eventId: number): Observable<EventTypeListItemViewModel[]> {
    return this.http.get<EventTypeListItemViewModel[]>(this.baseUrl + 'GetEventTypesListForEvent/' + eventId);
  }

  addEventType(eventType: EventTypeDetailsViewModel) {
    return this.http.post<EventTypeDetailsViewModel>(`${this.baseUrl}AddEventType`, eventType);
  }

  editEventType(eventType: EventTypeDetailsViewModel) {
    return this.http.post<EventTypeDetailsViewModel>(`${this.baseUrl}EditEventType`, eventType);
  }

  deleteEventTypes(Ids: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}DeleteEventTypes`, Ids);
  }
}
